import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonComponent } from '@shared/components/button/button.component';
import { SharedModule } from '@shared/modules/shared.module';

@Component({
	selector: 'app-payment-required',
	imports: [SharedModule, ButtonComponent],
	templateUrl: './payment-required.component.html',
	styleUrl: './payment-required.component.scss',
})
export class PaymentRequiredComponent {
	constructor(private router: Router) {}

	goToDashboard(): void {
		this.router.navigate(['/dashboard']);
	}

	contactSupport(): void {
		// TODO: Implement logic to contact support
	}
}
